// Typelizer digest 3891b0c3c51fd0bab433834ca89dcf42
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../../runtime'
import { buildUrl } from '../../../../runtime'

export default {
  /** POST /c/:company_id/ledger/review_queue/payments/:payment_id/verification */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/review_queue/payments/:payment_id/verification', params, options),
    method: 'post',
  }),
}
